

import React, { Component } from 'react'
import { Button, Icon, Container, Divider, Grid, Header, Image, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom';

import DesktopContainer from './DesktopContainer'
import DesktopContainer2 from './DesktopContainer2'

import Logo from '../../../static/healthcare/11.jpg'


import phone1 from '../../../static/phone/1.png'
import phone2 from '../../../static/phone/2.png'
import phone3 from '../../../static/phone/3.png'
import healthcare from '../../../static/healthcare/4.jpg'
import Fade from 'react-reveal/Fade';



export class LandingPage extends Component {
  render() {
    return (
      <div>
        <DesktopContainer></DesktopContainer>



        {/* <Container style={{minHeight: 150, 
            
        }}>

     

            <div style={{
              
              width: '75%', marginLeft: '5px', padding: '10px', float: 'left', textAlign: 'justified',
             
            }}>
              <h2>Connect with your Team</h2>
              <h3>

                Be productive and connected at work, at home, on the go, and everywhere in between.
            </h3>


            </div>

            <Button primary size='huge' style={{ padding: '40px', marginLeft: '5px' }} >

              <Link name='Get Started' style={{ marginBottom: '.5em', color: 'white' }} to="/cardlist/card/add" as={Link}>
                Get Started   <Icon name='right arrow' /></Link>
            </Button>

 

        </Container> */}



<DesktopContainer2></DesktopContainer2>


        <div
          style={{
            // background: '#1B1C1D',
            borderTop: "0px solid #1B1C1D",
            paddingRight: '13vw'

            // borderTop: "1px solid #1B1C1D",

            // border: "1px solid transparent",
          }}>

          <div
          
          style={{
            background: 'white', minHeight: 150, width: '95%', textAlign: 'justified',
            borderTop: "0px solid '#1678C2",
            borderBottom: "0px solid transparent",
            paddingLeft: '13vw'
          }}
          >

            <br></br>


            <div>

              
              <div style={{
                width: '60%', padding: '0px', float: 'left', textAlign: 'justified',

              }}>
                <h2 style={{ fontSize: '2em' }}>Connect with your Team</h2>
                <p style={{ fontSize: '1.33em' }}>

                  Be productive and connected at work, on the go, and everywhere in between.
                </p>


              </div>

              <Button primary size='huge' style={{

                marginTop: '3vh',
                marginLeft: '1vw',
                maxWidth: '50vw',
                minWidth: '20vw',
                //  marginRight: '5vw',


              }} >

                <Link name='Get Started' style={{
                  marginBottom: '.5em', color: 'white',
                  fontSize: '1.13em',

                }} to="/register" as={Link}>
                  Create new account
                   {/* <Icon name='right arrow' /> */}

                </Link>
              </Button>

            </div>

          </div>

        </div>









        <div>



          {/* 
        <div style={{ background: 'yellow', minHeight: 150, width:'75%' }}>

          


          <Button primary size='huge'  >

            <Link name='Get Started' style={{ marginBottom: '.5em', color: 'white' }} to="/cardlist/card/add" as={Link}>
              Get Started   <Icon name='right arrow' /></Link>
          </Button>


  


        </div>

        <div style={{ width: '25%', background: '#1B1C1D', float:'right' }}>

    </div> */}

          <Segment style={{ padding: '4em 0em', }} vertical>
            <Grid container stackable verticalAlign='middle'>



              <img style={{ width: '110%', marginLeft: '-5vw' }} src={Logo}></img>





              <Fade left cascade>
                <div style={{
                  marginTop: '-10em', background: 'white', width: '100px',
                  height: '150px', minHeight: '80%', minWidth: '80%', marginLeft: '-70px'

                }}>


                  <Header as='h4' content='Group chats and patient data, together in one place' style={{
                    marginLeft: '70px', fontSize: '4vh', fontWeight: 'normal', marginTop: '.75em', color: '#1678C2',
                    minWidth: '25%'
                  }} />



                  {/* <p style={{ color:'#1678C2', fontWeight: 'normal',  width: '15em',   fontSize: '4vw',    marginLeft: '70px'   }}>
                          Email and calendar, together in one place
                          </p>
  */}

                  {/* <Header as='h1' content=' '   style={{ fontSize: '4.5em', fontWeight: 'normal', marginBottom: '.5em', color:'#FAF0E6' }} /> */}

                </div>
              </Fade>

              <br></br>
                <br></br>
           
                  

              <Segment style={{ padding: '0em' }} vertical>
            <Grid celled='internally' columns='equal' stackable>
              <Grid.Row textAlign='center'>
                <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                  <Header as='h1' style={{ fontSize: '1.5em' }}>
                  Create a group chat for each patient
              </Header>
              <Fade left cascade>

              <Image style={{ width: '80%'  }} src={phone1}></Image>
              </Fade>

                </Grid.Column>

                <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                  <Header as='h1' style={{ fontSize: '1.5em' }}>
                    Upload files or images to group chats
              </Header>
              <Fade left cascade>
              <Image style={{ width: '80%'  }} src={phone2}></Image>
              </Fade>
                </Grid.Column>

                <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                  <Header as='h1' style={{ fontSize: '1.5em' }}>
                    Add members to each chat room
              </Header>
              <Fade left cascade>
              <Image style={{ width: '80%'  }} src={phone3}></Image>
              </Fade>
                </Grid.Column>

              </Grid.Row>
            </Grid>
          </Segment>




          




              <Grid.Row>


                

                <Grid.Column width={8}>
            
{/* 
                  <Segment style={{ padding: '0em' }} vertical>
            <Grid celled='internally' columns='equal' stackable>
              <Grid.Row textAlign='center'>
                <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                  <Header as='h3' style={{ fontSize: '2em' }}>
                    "What a Company"
              </Header>

          
              <Image style={{ width: '80%'  }} src={phone2}></Image>


                </Grid.Column>
                <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                  <Header as='h3' style={{ fontSize: '2em' }}>
                    "I shouldn't have gone with their competitor."
              </Header>
          
              <Image style={{ width: '80%'  }} src={phone2}></Image>

                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment> */}



              {/* <img style={{ width: '80%', marginLeft: '-5vw' }} src={phone2}></img> */}



              {/* <img style={{ width: '80%', marginLeft: '-5vw' }} src={phone3}></img>  */}


                  <Header as='h3' style={{ fontSize: '2em' }}>
                    We Help Organizations and Healthcare Workers
                  


              </Header>
                  <p style={{ fontSize: '1.33em' }}>
                    We can give your organization the ability to connect with other healthcare professionals from different organizations.  
                    Each patient case can be showned through inviation.   
                    Help your patients by empowering your healthcare professionals to connect.
              </p>
                  <Header as='h3' style={{ fontSize: '2em' }}>
                   Add physicians who work at home or coming out of retirement. 
              </Header>
                  <p style={{ fontSize: '1.33em' }}>
                  If your organization needs to add healthcare professionals for your patient cases, it can be done virtually with mlstudio.ai 
              </p>
                </Grid.Column>
                <Grid.Column floated='right' width={6}>
                  <Image bordered rounded size='large' src={healthcare} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column textAlign='center'>
                  <Button size='huge'>Check Them Out</Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>






          <Segment style={{ padding: '8em 0em' }} vertical>
            <Container text>
              <Header as='h3' style={{ fontSize: '2em' }}>
              We have tools for radiologist for chest xrays
          </Header>
              <p style={{ fontSize: '1.33em' }}>
                Instead of focusing on content creation and hard work, we have learned how to master the
                art of doing nothing by providing massive amounts of whitespace and generic content that
                can seem massive, monolithic and worth your attention.
          </p>
              <Button as='a' size='large'>
                Read More
          </Button>
              <Divider
                as='h4'
                className='header'
                horizontal
                style={{ margin: '3em 0em', textTransform: 'uppercase' }}>
                <a href="/" >Case Studies</a>
              </Divider>
              <Header as='h3' style={{ fontSize: '2em' }}>
                Did We Tell You About Our Bananas?
          </Header>
              <p style={{ fontSize: '1.33em' }}>
                Yes I know you probably disregarded the earlier boasts as non-sequitur filler content, but
                it's really true. It took years of gene splicing and combinatory DNA research, but our
                bananas can really dance.
          </p>
              <Button as='a' size='large'>
                I'm Still Quite Interested
          </Button>
            </Container>
          </Segment>



        </div>




      </div>
    )
  }
}
export default LandingPage
